import { render } from "./video-item.vue?vue&type=template&id=a042765a&scoped=true"
import script from "./video-item.vue?vue&type=script&lang=js"
export * from "./video-item.vue?vue&type=script&lang=js"

import "./video-item.vue?vue&type=style&index=0&id=a042765a&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a042765a"]])

export default __exports__